import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MomentDateAdapter, MOMENT_DATE_FORMATS } from '../utils/DateAdapter';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginController } from './controllers/login.controller';
import { LoaderService } from './services/loader.service';
import { LoginService } from './services/login.service';
import { SharedModule } from './shared/shared.module';


registerLocaleData(localePt);

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule
    ],
    providers: [
        LoaderService,
        LoginService,
        LoginController,
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
        { provide: DateAdapter, useClass: MomentDateAdapter }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
